import { ErrorBoundary } from '@sentry/react'
import propTypes from 'prop-types'
import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import ImgBrokenLink from 'legacy/assets/img/empty-containers-broken-link.png'
import ImgLogoV4 from 'legacy/assets/svg/icons/icon_logo_v4.svg'
import { screen } from 'legacy/styles/screen'

const Page = styled.div`
  text-align: center;

  > * {
    margin-top: 2em;
  }

  a {
    display: block;
  }

  h1 {
    font-size: 2em;
    font-weight: bold;
  }

  p {
    font-size: 1em;
    font-weight: normal;

    span {
      ${screen.md} {
        display: block;
      }
    }
  }

  button {
    background: ${getToken('color-primary')};
    border: 1px solid transparent;
    border-radius: 5px;
    color: ${getToken('color-neutral-lightest')};
    font-size: 1em;
    line-height: 1.3;
    padding: 0.5em 1.5em;
  }
`

const Fallback = ({ resetError }) => (
  <Page>
    <a href="/">
      <img src={ImgLogoV4} alt="go to loadsmart" width="135" height="26" />
    </a>
    <img src={ImgBrokenLink} alt="" width="277" height="160" />
    <h1>Oops...</h1>
    <p>
      This is embarrassing, but something went wrong with the page.
      <span> It&#39;s not you. Just try again or wait a few minutes.</span>
    </p>
    <button onClick={resetError} type="button">
      Retry
    </button>
  </Page>
)

Fallback.propTypes = {
  resetError: propTypes.func.isRequired,
}

ErrorBoundary.defaultProps = {
  fallback: Fallback,
  showDialog: false,
}

export { ErrorBoundary }
export default ErrorBoundary
